var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"expired-tag"},[_c('dg-text',{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.$t("common.profile.accreditations.expired")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }